import React,{useEffect} from 'react'
import Symbol from './Symbol';
import NavigationIcon from '@mui/icons-material/Navigation';
import ProgressBar from './ProgressBar';
export default function HighlightBox(props) {
    
    return (
        <div className="flexCenter highlightBox">
            <p className="smallHeading">{props.title}</p>
            <p className="values">{props.value.toFixed(2)}<span>{props.unit}</span></p>
            {props.title==="Wind Status"?
             <Symbol name={()=>{
                return <NavigationIcon/>
            }} title={"wsw"}/>
            :null}
            {props.title==="Humidity"?<ProgressBar value={props.value}/>:null}
        </div>
    )
}
